export default __webpack_public_path__ + "static/media/worldTrust.88ebeb01.svg";